import type { AxiosRequestConfig } from 'axios'

export function buildLanguageHeaderConfig(languageCode?: string | null): AxiosRequestConfig {
  return languageCode ? { headers: { 'X-Language-Code': languageCode } } : {}
}
